export default "__VITE_ASSET__897ddca8__"